// Custom GraphQL Mutations
// This file contains simplified versions of mutations to avoid circular dependency issues
// These mutations exclude problematic relationship fields that cause GraphQL resolution errors

import type * as APITypes from '../API'

type GeneratedMutation<InputType, OutputType> = string & {
	__generatedMutationInput: InputType
	__generatedMutationOutput: OutputType
}

export const createProposalsSimplified =
	/* GraphQL */ `mutation CreateProposalsSimplified(
  $input: CreateProposalsInput!
  $condition: ModelProposalsConditionInput
) {
  createProposals(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    quoteId
    quoteType
    clientId
    contactId
    status
    noofInvoices
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientTaxType
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    paymentTerms
    total
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    proposalsBankProfileName
    proposalsBank
    proposalsIban
    proposalsBic
    proposalsAccountName
    drafts {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        invoiceNumber
        amount
        amountAfterTax
        taxAmount
        invoiceDate
        invoiceDueDate
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    poDate
    poName
    poAmount
    poCurrency
    poNotes
    poDocuments {
      bucket
      region
      key
      identityId
    }
    poVersion
    prevStatus
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    _version
    _deleted
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.CreateProposalsMutationVariables,
		APITypes.CreateProposalsMutation
	>

export const updateProposalsSimplified =
	/* GraphQL */ `mutation UpdateProposalsSimplified(
  $input: UpdateProposalsInput!
  $condition: ModelProposalsConditionInput
) {
  updateProposals(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    quoteId
    quoteType
    clientId
    contactId
    status
    noofInvoices
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientTaxType
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    paymentTerms
    total
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    proposalsBankProfileName
    proposalsBank
    proposalsIban
    proposalsBic
    proposalsAccountName
    drafts {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        invoiceNumber
        amount
        amountAfterTax
        taxAmount
        invoiceDate
        invoiceDueDate
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    poDate
    poName
    poAmount
    poCurrency
    poNotes
    poDocuments {
      bucket
      region
      key
      identityId
    }
    poVersion
    prevStatus
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    _version
    _deleted
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.UpdateProposalsMutationVariables,
		APITypes.UpdateProposalsMutation
	>

export const createInvoicesSimplified =
	/* GraphQL */ `mutation CreateInvoicesSimplified(
  $input: CreateInvoicesInput!
  $condition: ModelInvoicesConditionInput
) {
  createInvoices(input: $input, condition: $condition) {
    id
    tenantId
    proposalId
    quoteType
    activeFlag
    originalInvoiceId
    creditInvoiceGenerated
    archivedDate
    paidDate
    paymentStatus
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientId
    contactId
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    clientTaxType
    clientNote
    isDetailed
    showBidLetter
    isClientTaxRate
    companyLogo
    bankProfileNumber
    invoicesBankProfileName
    invoicesBank
    invoicesIban
    invoicesBic
    invoicesAccountName
    title
    invoiceNumber
    poNumber
    invoiceAmountPercentage
    amount
    amountAfterTax
    taxAmount
    taxDetails {
      taxRate
      taxPercentage
      taxAmount
      taxableAmount
    }
    sectionDetails {
      type
      amount
    }
    sectionDetailsByQuote {
      type
      amount
    }
    sectionDetailsByAccSection {
      type
      amount
    }
    salesAccNumberType
    balancePercentage
    balanceAmount
    invoiceDate
    invoiceDueDate
    description
    proposalsDraft {
      generated
      poNumber
      amount
      invoiceId
    }
    invoiceType
    assignedTenantId
    assignedTenantName
    lastExportedDate
    draftEmailData {
      toEmail
      subject
      body
    }
    createdOn
    updatedOn
    _version
    _deleted
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.CreateInvoicesMutationVariables,
		APITypes.CreateInvoicesMutation
	>

export const updateInvoicesSimplified =
	/* GraphQL */ `mutation UpdateInvoicesSimplified(
  $input: UpdateInvoicesInput!
  $condition: ModelInvoicesConditionInput
) {
  updateInvoices(input: $input, condition: $condition) {
    id
    tenantId
    proposalId
    quoteType
    activeFlag
    originalInvoiceId
    creditInvoiceGenerated
    archivedDate
    paidDate
    paymentStatus
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientId
    contactId
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    clientTaxType
    clientNote
    isDetailed
    showBidLetter
    isClientTaxRate
    companyLogo
    bankProfileNumber
    invoicesBankProfileName
    invoicesBank
    invoicesIban
    invoicesBic
    invoicesAccountName
    title
    invoiceNumber
    poNumber
    invoiceAmountPercentage
    amount
    amountAfterTax
    taxAmount
    taxDetails {
      taxRate
      taxPercentage
      taxAmount
      taxableAmount
    }
    sectionDetails {
      type
      amount
    }
    sectionDetailsByQuote {
      type
      amount
    }
    sectionDetailsByAccSection {
      type
      amount
    }
    salesAccNumberType
    balancePercentage
    balanceAmount
    invoiceDate
    invoiceDueDate
    description
    proposalsDraft {
      generated
      poNumber
      amount
      invoiceId
    }
    invoiceType
    assignedTenantId
    assignedTenantName
    lastExportedDate
    draftEmailData {
      toEmail
      subject
      body
    }
    createdOn
    updatedOn
    _version
    _deleted
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.UpdateInvoicesMutationVariables,
		APITypes.UpdateInvoicesMutation
	>
